<div class="tab-pane" role="tabpanel" id="permiso_notariado">
    <fieldset id="agregar_permiso_notariado" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group">

                                <label for="acreditacion" class="col-md-2">Acreditación Mediante</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Acreditación" id="acreditacion" name="acreditacion" formControlName="acreditacion" (change)="add_permiso_notariado()" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="fecha" class="col-md-2">Fecha</label>
                                <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate"  id="fecha" name="fecha" formControlName="fecha" (dateInput)="add_permiso_notariado($event,'input')" (dateChange)="add_permiso_notariado($event,'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>

                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group">

                                <label for="escritura" class="col-md-2">Fecha Escritura Publica</label>
                                <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp4"  id="escritura" name="escritura"  formControlName="escritura" (dateInput)="add_permiso_notariado($event, 'input2')" [max]="maxDate" (dateChange)="add_permiso_notariado($event, 'change2')">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="notario" class="col-md-2">Ante Notario </label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        
                                        <span matPrefix>Sr(a)&nbsp;</span>
                                        <input matInput placeholder="Notario" id="notario" name="notario" formControlName="notario" (change)="add_permiso_notariado()">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>